
































import { IDialog } from "@/lib/interfaces/dialog.interface";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IRental, Rental } from "@/models/rental.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import DropAreaMulti from "../files/DropAreaMulti.vue";
import RentalForm from "../partner/report/v2/rental/RentalForm.vue";

@Component({
  components: { RentalForm, DropAreaMulti },
  filters: {}
})
export default class RentalUpdateDialog extends mixins(PermissionMixin, RulesMixin) implements IDialog {
  @Prop({ default: false }) value!: boolean;
  @Prop() rental!: IRental;

  dialog: boolean = this.value;
  isLoading = false;
  isEditValid = false;

  editRental: IRental | null = null;

  file: File | null = null;

  get files(): File[] {
    if (this.file) {
      return [this.file];
    }
    return [];
  }

  set files(files: File[]) {
    if (files.length > 0) {
      this.file = files[0];
    } else {
      this.file = null;
    }
  }

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      this.editRental = new Rental(this.rental);
    }
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  async update() {
    if (this.editRental === null) {
      return;
    }

    try {
      this.isLoading = true;

      if (this.file) {
        const rentalDocument = await this.editRental.uploadDocument(this.file);
        this.editRental.documentId = rentalDocument.id;
        this.rental.document = rentalDocument;
      }

      await this.editRental.update();

      this.rental.map(this.editRental);
    } catch (error) {
      handleError(error);
    } finally {
      this.close();
      this.isLoading = false;
    }
  }

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }
}
